export const removeEmptyStringsFromObject = (objectToClean: Record<string, string>): Record<string, string> =>
  Object.fromEntries(Object.entries(objectToClean).filter(([, value]) => value !== ''))
